import Link from "next/link";
import { getProductPathForPeptide } from "@/lib/research/saleor-product-map";
import { publicStorePath } from "@/lib/storefront/public-url";

interface PeptideRefLinkProps {
	/** Canonical research-peptide slug (e.g. "bpc-157", "ghk-cu"). */
	slug: string;
	/** Optional display name; falls back to the slug if omitted. */
	displayName?: string;
	/** Current locale — needed to build the correct locale-prefixed href. */
	locale: string;
	className?: string;
}

/**
 * Renders a peptide reference as either a link to the live Saleor product page
 * (when a product exists in the allow-list) or a plain text label (when the
 * peptide is pipeline/restricted/not yet a live product).
 *
 * Server Component — no client-side state needed.
 */
export function PeptideRefLink({ slug, displayName, locale, className = "" }: PeptideRefLinkProps) {
	const label = displayName ?? slug;
	const productPath = getProductPathForPeptide(slug);

	if (productPath) {
		const href = publicStorePath(locale, productPath);
		return (
			<Link
				href={href}
				className={`font-medium text-primary underline-offset-2 hover:underline ${className}`}
			>
				{label}
			</Link>
		);
	}

	return <span className={`font-medium text-foreground ${className}`}>{label}</span>;
}
